<template>
  <div class="period" data-testid="period">
    <Heading class="period__heading" :level="2">
      Quando pretende concluí-lo?
    </Heading>
    <LoaderIndicator v-if="isLoading" with-container />
    <SelectionBox
      v-else-if="periods"
      class="period__selection-box"
      aria-label="Quando pretende concluí-lo?"
      type="single"
      :value="selectedOption"
      :options="options"
      @change="handleChangeOption"
    />
    <ButtonContainer class="period__button-container">
      <template #button-primary>
        <ButtonPrimary
          label="Continuar"
          size="large"
          :disabled="isDisabled"
          @click="onClick"
        />
      </template>
    </ButtonContainer>
  </div>
</template>

<script lang="ts" setup>
import { computed, inject, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router/composables';
import { notify } from '@/modules/common/helpers/notification';
import { NotificationTypes } from '@/modules/common/services/http/notification';

import {
  Heading,
  LoaderIndicator,
  SelectionBox,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';

import { getPeriods, IPeriod } from '@/modules/catalog/services/funds';

const router = useRouter();

const updateData = inject(
  'updateData',
  (key: string, name: object, askForInvestorType: boolean) => ({
    key,
    name,
    askForInvestorType
  })
);

const selectedOption = ref('');
const isLoading = ref(true);
const periods = ref<IPeriod[] | null>(null);

const options = computed(() => {
  return periods.value?.map(item => {
    return {
      title: item.period.formatted,
      value: item.period.value
    };
  });
});

const selectedOptionFormatted = computed(() => {
  const data = periods.value?.filter(
    item => item.period.value === selectedOption.value
  );

  return data![0].period;
});

const askForInvestorType = computed(() => {
  const data = periods.value?.filter(
    item => item.period.value === selectedOption.value
  );

  return data![0].askForInvestorType;
});

const isDisabled = computed(() => {
  return !selectedOption.value;
});

function handleChangeOption(value: string) {
  selectedOption.value = value;
}

function onClick() {
  updateData('period', selectedOptionFormatted.value, askForInvestorType.value);
}

async function fetchPeriods() {
  try {
    isLoading.value = true;

    periods.value = await getPeriods();
  } catch {
    notify({
      group: 'wrn-notifications',
      text: 'Não foi possível carregar as informações. Aguarde alguns instantes e tente novamente.',
      type: NotificationTypes.error
    });

    router.push({ name: 'catalog' });
  } finally {
    isLoading.value = false;
  }
}

onMounted(async () => {
  await fetchPeriods();
});
</script>

<style lang="less" scoped>
.period {
  max-width: 832px;
  margin: 0 auto;
  padding: 0 @size-spacing-x400 @size-spacing-x1800;

  &__heading {
    margin-top: @size-spacing-x1100;
  }

  &__selection-box {
    margin-top: @size-spacing-x1000;
  }

  &__button-container {
    background-color: @background-secondary;
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 20;
  }
}
</style>
